module.exports = __webpack_public_path__ + "img/logo.402730de.jpg";